import React from "react";

const WhatWeDidDifferently = () => {
  return (
    <div className="about_area aws-challenge">
      <div className="container">
        <div className="row">
             
         <div className="col-lg-12 col-md-6 col-sm-12 col-xs-6">
           <div className="section_main_title mt-80 mb-3">
                <h3>What We Did Differently</h3>
              
              </div>
            <div className="singel_about_left text-left">
              <p>At ProPlus, we didn’t roll out a huge transformation plan. We started with a simple principle:
the same campaign doesn’t work the same way everywhere.
So, instead of templating campaigns, we rebuilt demand generation around three strategic levers.
</p>
<p><b>1. Regions Were Treated as Strategic Markets, Not Just Geographies </b></p>
<p>We looked at 11 key regions independently, factoring in tech maturity, buying timelines, and competitive noise.
</p>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                
              </div>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                </div>
                <div className="singel-about-content">
                 
                  <p><b>For Example:</b><br/>
                  ● In India, the volume and conversion potential were high, especially in Electronics, Energy, and Food.
 <br/> ● SEA markets needed signal acceleration, so lead delivery models worked better.
 <br/> ● In Vietnam, direct campaigns outperformed longer nurturing flows.

                  </p>
                </div>
              </div>
             
             
            </div>
          </div>
           <div className="col-lg-12 col-md-6 col-sm-12 col-xs-6">
           
            <div className="singel_about_left mb-30 text-left">
                <p><b>2. We re-evaluated 10+ industry verticals not by what they sold, but by how their buyer groups operated and aligned. </b></p>

              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                 
                </div>
                <div className="singel-about-content">
                  
                  <p><b>Key Findings:</b> <br/>
                 ● Semiconductors showed consistent traction across both India and Southeast Asia, driven by clear ownership within technical buying units.
<br/>  ● Flexible Manufacturing emerged as a high-performing vertical across four regions, with well-defined decision-making clusters.
 <br/>●Aerospace & Defense required more enriched signals, as influence within buying groups was highly distributed and timing-sensitive.
                  </p>
                </div>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </div>
  );
};

export default WhatWeDidDifferently;
